import React, { FC } from 'react';
import { RootState, AppDispatch } from '../store';
import { useSelector, useDispatch } from 'react-redux';
import { DeviceType, Orientation, Platform, WriteDirection, Lightbox } from 'sofa-reborn-react';
import FailedPrompt from '../components/FailedPrompt';
import { setCurrentLightbox } from '../store/application/actions';
import { setUpptackaSaveFail } from '../store/checkout';

const FailedPromptContainer: FC = () => {
	const deviceType = useSelector<RootState, DeviceType>((state) => state.deviceInfo.deviceType);
	const orientation = useSelector<RootState, Orientation>((state) => state.deviceInfo.orientation);
	const platform = useSelector<RootState, Platform>((state) => state.deviceInfo.platform);
	const writeDirection = useSelector<RootState, WriteDirection>(
		(state) => state.localization.writeDirection
	);
	const currentLightbox = useSelector<RootState, Lightbox>(
		(state) => state.application.currentLightbox
	);
	const upptackaSaveFail = useSelector<RootState, boolean>(
		(state) => state.checkout.upptackaSaveFail
	);
	const dispatch = useDispatch<AppDispatch>();

	return (
		<FailedPrompt
			deviceType={deviceType}
			orientation={orientation}
			writeDirection={writeDirection}
			platform={platform}
			upptackaSaveFail={upptackaSaveFail}
			showPrompt={currentLightbox === 'failed-prompt'}
			onClick={() => {
				if (upptackaSaveFail) {
					dispatch(setUpptackaSaveFail(false));
				}
				dispatch(setCurrentLightbox('none'));
			}}
		></FailedPrompt>
	);
};

export default FailedPromptContainer;
